 :sm="6" :xs="6"<template>
    <div class="maintainer-list relative">
        <div class="buttons">
<!--            <el-button @click="reset">重置</el-button>-->
<!--            <el-button @click="search">筛选</el-button>-->
        </div>

        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="5" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">特属服务对象姓名：</span>
                <el-input v-model="user_name" placeholder="搜索用户账户"></el-input>
            </el-col>
            <el-col :md="6" :lg="5" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">日志类型：</span>
                <el-select
                    clearable
                    class="status" v-model="type" placeholder="请选择日志类型" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="5" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">&ensp;&ensp;&ensp;&ensp;特属专家姓名：</span>
                <el-input v-model="doctor_name" placeholder="姓名模糊搜索" />
            </el-col>
            <el-col :md="6" :lg="5" :xl="5" :sm="6" :xs="6">
                <span class="fs-14 pd-r-10">时间范围：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
            <el-col :md="6" :lg="5" :xl="5" :sm="6" :xs="6">
                <el-button @click="reset">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row>
        <el-table :data="tableData" border style="width: 100%">
<!--            <el-table-column prop="id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="80" prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="doctor_name" label="特属专家姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column  prop="user_name" label="特属服务对象姓名" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="240" prop="type_text" label="日志类型" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="240" prop="meet_date" label="会面日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="240" prop="create_time" label="操作日期" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="180" prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button  @click="goDetail(scope.row)" type="text" size="small">
                    档案详情
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";

    export default {
        inject: ['health_record_params'],
        data() {
            return {
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allType: [
                    {
                        id: '1',
                        name: '创建档案'
                    },
                    {
                        id: '2',
                        name: '更新档案'
                    },
                ],
                //搜索栏
                doctor_name: '',
                user_name: '',
                type: '',
                start_date: '',
                end_date: '',
                search_expired_date: '',
                is_submit: false,
            };
        },
        mounted() {
            //获取日志列表
            this.user_name = this.$route.params.user_name || ''
            this.doctor_name = this.$route.params.doctor_name || ''
            this.getList();
            localStorage.setItem('prev_page', 'log_list')
        },
        methods: {
            //获取日志列表
            getList() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'healthrecordLogListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        type: this.type,
                        user_name: this.user_name,
                        doctor_name: this.doctor_name,
                        start_date: this.start_date,
                        end_date: this.end_date,
                    },
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    let len = res.data.data.list.length
                    for (var i = 0; i < len; i++) {
                        // 序号
                        res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1

                        switch (res.data.data.list[i].type) {
                            case '1':
                                res.data.data.list[i].type_text = '创建健康档案';
                                break;
                            case '2':
                                res.data.data.list[i].type_text = '更新健康档案';
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            dateChange(e){
                if (!e) {
                    this.search_expired_date = null
                    this.start_date = ''
                    this.end_date = ''
                }
            },
            //搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                if (this.search_expired_date) {
                    this.start_date = this.search_expired_date[0];
                    this.end_date = this.search_expired_date[1];
                }
                this.getList();
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            reset() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.type = '';
                this.user_name = '';
                this.doctor_name = '';
                this.page = 1;
                this.start_date = "";
                this.end_date = "";
                this.search_expired_date = "";
                this.getList();
            },
            goDetail(data) {
                this.$router.push({
                    name: "healthrecordsDetail", query: {
                        id: data.record_id,
                    }
                }).catch(err =>{});
            },

        },
        watch: {
            health_record_params: {
                immediate: true,
                deep: true,
                handler(nVal, oVal) {
                    process.env.NODE_ENV !== 'production' && console.log(oVal,nVal.user_id , this.user_id , nVal.obj_id , this.obj_id)
                    if (oVal && (nVal.user_name != this.user_name || nVal.doctor_name != this.doctor_name)) {
                        this.doctor_name = nVal.doctor_name;
                        this.user_name = nVal.user_name;
                        process.env.NODE_ENV !== 'production' && console.log('getList')
                        this.getList();
                    } else {
                        // this.doctor_name = nVal.doctor_name;
                        // this.user_name = nVal.user_name;
                        // this.getList();
                    }

                },
            },
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";


    .inputs .el-select.status .el-input {
        width: 100%;
    }
</style>

